import { Component } from '@theme/component';
class FiveToeDeliveryDate extends Component {
  #interval;
  connectedCallback() { super.connectedCallback(); this.updateDate(); clearInterval(this.#interval); this.#interval = setInterval(() => this.updateDate(), 60000); }
  disconnectedCallback() { clearInterval(this.#interval); super.disconnectedCallback(); }
  updateDate() {
    const date = new Date(); date.setDate(date.getDate() + 1);
    const time = this.querySelector('[data-ship-date]');
    if (!time) return;
    time.dateTime = `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
    time.textContent = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' }).format(date);
  }
}
if (!customElements.get('five-toe-delivery-date')) customElements.define('five-toe-delivery-date', FiveToeDeliveryDate);
